import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';

import { onUserLogout } from 'actions/user';
import UserMenu from 'components/UserMenu';

interface Props {
  show: boolean;
  onClose: () => void;
}
const UserMenuContainer = ({ show, onClose }: Props) => {
  const dispatch = useDispatch();
  const userData = useSelector((state: RootState) => state.user.accountResult);

  return (
    <UserMenu
      isAdmin={userData?.type === 'admin'}
      isSuperAdmin={userData?.type === 'superAdmin' || userData?.type === 'supportImplementation'}
      isApprover={!!userData?.isGroupApprover}
      isTravelArranger={userData?.isTravelArranger ?? userData?.type === 'admin'}
      fullName={`${userData?.name} ${userData?.lastName}`}
      email={userData?.email || ''}
      show={show}
      onClose={onClose}
      onLogout={() => dispatch<any>(onUserLogout())}
    />
  );
};

export default UserMenuContainer;
